export function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
}

export var delay = (time) => new Promise(resolve => setTimeout(resolve, time));



/** WEBPACK FOOTER **
 ** ./src/assets/js/apps/blog/utils/Timer.js
 **/